import styles from "./Header.module.scss";
import CloseIcon from "../icons/HeaderClose";
import useWindowSize from "../../hooks/useWindowSize";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants/routes";

const CommonCloseModule = () => {
  const { windowSize } = useWindowSize();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isFiltersPage = pathname === ROUTES.FILTERS;
  const isChatTestPage = pathname === ROUTES.GID;

  return (
    <button
      onClick={() => navigate(-1)}
      className={`${windowSize === "mobile" ? styles.mobileFilterButton : styles.desctopFilterButton} ${
        isFiltersPage || isChatTestPage ? styles.closeFilterButton : ""
      }`}
    >
      <CloseIcon isMobile={windowSize === "mobile"}/>
    </button>
  )
}

export default CommonCloseModule;
